// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sk-tooltip[data-v-2125409c] {\n  position: absolute;\n  z-index: 100;\n}\n.tooltip-root .sk-tooltip__text[data-v-2125409c] {\n  padding: 5px 10px;\n  background-color: rgba(51, 51, 51, 0.95);\n}\n", ""]);
// Exports
module.exports = exports;
